import { ChainType } from '@lifi/types';
import { getCapabilities } from 'viem/experimental';
import { getAction } from 'viem/utils';
import { config } from '../../config.js';
export async function isBatchingSupported({ client, chainId, }) {
    const _client = client ??
        (await config.getProvider(ChainType.EVM)?.getWalletClient?.());
    if (!_client) {
        throw new Error('WalletClient is not provided.');
    }
    try {
        const capabilities = (await getAction(_client, getCapabilities, 'getCapabilities')(undefined));
        return capabilities[chainId]?.atomicBatch?.supported ?? false;
    }
    catch {
        // If the wallet does not support getCapabilities or the call fails,
        // we assume that atomic batch is not supported
        return false;
    }
}
//# sourceMappingURL=isBatchingSupported.js.map